import { Component, OnInit, ViewChildren } from '@angular/core';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Title, Meta } from '@angular/platform-browser';
import { DamserviceService } from "../dam/damservice.service";
import { OrganisationService } from "../create-organisation/organisation.service";
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from "angularx-social-login";
import { FormBuilder, Validators } from '@angular/forms';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { SubscriptionService } from "../subscription/subscription.service";
import { InboxservicesService } from "../inboxarea/inboxservices.service";

@Component({
  selector: 'app-videos-kit',
  templateUrl: './videos-kit.component.html',
  styleUrls: ['./videos-kit.component.css']
})
export class VideosKitComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService,
    private damService: DamserviceService,
    private organisationService: OrganisationService,
    private authService: AuthService,
    private router: Router,
    private titleService: Title,
    private metaTagService: Meta,
    private fb: FormBuilder,
    private googleAnalyticsService: GoogleAnalyticsService,
    private subscriptionService: SubscriptionService,
    private inboxService: InboxservicesService,
  ) { }

  workspaces = [];
  boards = [];
  notifications = [];
  searchTerms: string[] = [];
  imagesList = [];
  imagesIds: Array<{id: any}> = [];
  boardIdsList = [];

  videosViewSection: boolean = true;
  searchImageslistSection: boolean = false;

  createWorkspaceStyle = "none";
  shareLinkStyle = "none";
  boardRenameStyle = "none";
  deleteBoardStyle = "none";

  isShowCreateWorkspaceError: boolean = false
  createWorkspaceErrorMessage: string;
  isShowCreateLoginWorkspaceError: boolean = false
  createWorkspaceLoginErrorMessage: string;

  currentUser: User;

  searchData: string = '';
  searchText: string = '';
  searchTextSet: any;
  moveBoardId: any;
  userPic: any;
  workspaceId: any
  workspaceName: string;
  boardId: any;
  showTopRightLoader: boolean = false;
  showLoaderBoardsList: boolean = false;
  planName: string;
  ownerEmail: string;
  ownerName: string;
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  planId: any;
  workspaceCountAllowed: any;
  totalWorkspaceCreated: any
  userRole: string;
  showLoader: boolean = false;
  isShowLoadingStatus: boolean = false;
  count: number = 0;
  showLeaveLoader: boolean = false;
  mobileView: boolean = false;
  deleteBoardId: any;
  deleteBoardName: string;
  downloadBoardName: string;
  sendSuccessfulErrorMsg: boolean = false;
  sendSuccessfulErrorMessage: string;
  showRenameLoader: boolean = false;
  sendSuccessful: boolean = false;
  successfullMessage: string;
  showLinkCopied: boolean = false;
  renameErrorMsg: string;
  boardCurrentName: any;
  editNameBoardId: any;
  boardNewName: any;
  boardname: string = '';
  sharedToken: any;
  fromAssets: boolean = false;
  allowDownloads: any;
  showComments: any;
  allowComments: any;
  allowDownloadSelected: boolean = true;
  showCommentSelected: boolean = false;
  allowCommentingSelected: boolean = false;
  isShowShareLinkGenerated: boolean = true;
  expiryLinkIn: any = "f";
  shareableLink: string;
  shareImageLink: any;
  isHideShareLinkGenerated: boolean = false;
  renameImageLink: any;

  public index;
  public selectedIndex;

  @ViewChildren("checkboxes") checkboxes;

  creatwWorkspace = this.fb.group({
    message: ['', Validators.required],
  });

  ngOnInit(): void {
    this.titleService.setTitle("Workspace Videos kit | Workspace | Crafttor");
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor Workspace provides you with number of boards you created and upload images to your boards keeping it secure and smooth to access images anytime.'},
      { name: 'keywords', content: 'boards, board, workspace, upload free illustrations, upload clean pixel illustrations, upload premium illustration, ' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }

    if (this.currentUser) {
      this.getWorkspaceDetails();
      this.getUserPic();;
    } else {
      this.router.navigate(['/login']);
    }
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    var boardDetails = JSON.parse(localStorage.getItem('boardDetails'));
    this.moveBoardId = boardDetails.boardId;
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.getCurrentUserData(this.workspaceId);
    this.index = boardDetails.boardIndex;
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          this.workspaces = data;
          this.ownerListApi();
        }else{
            this.router.navigate(['/create-workspace']);
          }
      });
    }else{
        this.router.navigate(['/login']);
    }
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000;
      this.consumedSpaceAllowed = data.current_dam_space/1000;
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000;
      this.planId = data.plan_id;
      this.workspaceCountAllowed = data.allowed_workspace;
      this.totalWorkspaceCreated = data.total_workspace_created;
    });
  }

  getCurrentUserData(workspaceId: any) {
    this.showTopRightLoader = true;
    this.damService.getCurrentUserData(workspaceId).subscribe((data: any) => {
      this.userRole = data.role;
      this.listWorkspace();
      this.getBoardsList();
    },
    (error) => {
      if (this.currentUser) {
        if(error.status == 500){
          // this.router.navigate(['/maintenance']);
        } else {

        }
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  getBoardsList() {
    this.showLoaderBoardsList = true;
    this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      this.boards = data;
      this.showTopRightLoader = false;
      this.showLoaderBoardsList = false;
    },
    (error) => {
      if(error.status == 400){
        this.showLoaderBoardsList = false;
        this.showTopRightLoader = false;
      } else {
        this.showLoaderBoardsList = false;
        this.showTopRightLoader = false;
      }
    });
  }

  selectWorkspace(id: any, title: string, userRole: string){
    this.workspaceName = title;
    this.workspaceId = id;
    this.getCurrentUserData(this.workspaceId);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: id,
      workspaceName: title, userRole: userRole }));
    this.router.navigate(['/dam']);
  }

  mainClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam']);
  }

  peopleClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/people']);
  }

  personalClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/personal']);
  }

  newBoardClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/create-board']);
  }

  archiveClick() {
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['dam/trash']);
  }

  inboxClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['dam/inbox']);
  }

  settingsClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/settings']);
  }

  getInitial(fullEmail: string) {
    const words = fullEmail.split(' ');
    let initials = '';

    if (words.length > 2) {
      initials = words.slice(0, 2).map(word => word.charAt(0)).join('').toUpperCase();
    } else {
      initials = words.map(word => word.charAt(0)).join('').toUpperCase();
    }

    return initials;
   }

   newCrafttorDummy(): void {

   }

   logOut(): void {
     this.authenticationService.logout();
     this.authService.signOut();
     this.router.navigate(['/home']);
   }

   getNotifications() {
     this.showLoader = true;
     this.newNotification ();
   }

   newNotification () {
     this.damService.newNotifications(this.workspaceId).subscribe((data: any) => {
       this.notifications = data['notifcation'];
       this.showLoader = false;
     });
   }

   showUpgradePlans(){
     window.scrollTo(0, 0);
     if (this.currentUser) {
       this.router.navigate(['/dam/subscription']);
     }
   }

   goToLibrary() {
     this.googleAnalyticsService.event('library_click_videos_kit_screen_click', 'library_click', this.currentUser.firstName +" "+this.currentUser.lastName);
     this.router.navigate(['/library']);
   }

   boardlistClick(boardName: string, boardId: any){
     this.boardId = boardId;
     this.searchTerms = [];
     this.isShowLoadingStatus = false;
     this.moveBoardId = boardId;
     this.count = 0;
     this.checkboxes.forEach((element) => {
       element.nativeElement.checked = false;
     });
     localStorage.setItem('boardDetails', JSON.stringify({ boardId: boardId, boardTitle: boardName}));
     this.router.navigate(['/dam/'+boardName]);
   }

   getName(fullEmail: string) {
     return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
   }

   getRandomColor() {
     var color = Math.floor(0x1000000 * Math.random()).toString(16);
     return '#' + ('000000' + color).slice(-6);
   }

   goToMarketplace() {
     window.open("https://crafttor.com/marketplace", "_blank");
   }

   goToFeedback() {
     window.open("https://workspace.crafttor.com/feedbacks", "_blank");
   }

   openFigma() {
     window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
   }

   openSketch() {
     window.open("https://crafttor.com/sketch", "_blank");
   }

   openIllustrator() {
     window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
   }

   newCrafttor(): void {
     this.openNewWorkspaceDialog();
   }

   openNewWorkspaceDialog() {
     this.createWorkspaceStyle = "block";
   }

   closeNewWorkspaceDialog() {
     this.createWorkspaceStyle = "none";
   }

   createWorkspace(workspaceName: any){
     if (this.currentUser) {
       if(this.creatwWorkspace.valid) {
         this.showLeaveLoader = true;
         this.isShowCreateWorkspaceError = false
         this.organisationService.createNewWorkspace(workspaceName).subscribe((data: any) => {
           this.showLeaveLoader = false;
           this.creatwWorkspace.reset();
           localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data.id,
             workspaceName: data.title, userRole: data.role }));
           this.router.navigate(['/dam']);
           this.closeNewWorkspaceDialog();
         },
         (error) => {
           if(error.status == 403){
             this.showLeaveLoader = false;
             this.isShowCreateWorkspaceError = true
             this.createWorkspaceErrorMessage = error.error.Message;
           } else {
             this.showLeaveLoader = false;
             this.isShowCreateWorkspaceError = true
             this.createWorkspaceErrorMessage = error.error.Message;
           }
        });
       }
     }else{
       this.isShowCreateLoginWorkspaceError = true
       this.createWorkspaceLoginErrorMessage = "Login to Continue";
     }
   }

   openEditBoardNames(boardId: any, boardTitle: any) {
     this.renameErrorMsg = "";
     this.boardCurrentName = boardTitle;
     this.editNameBoardId = boardId;
     this.boardNewName = boardTitle;
     this.boardRenameStyle = "block";
   }

   closeEditBoardNames() {
     this.renameErrorMsg = "";
     this.boardRenameStyle = "none";
   }

   editBoardNamesApi(){
     this.renameErrorMsg = "";
     this.showRenameLoader = true;
     this.damService.editBoardName(this.workspaceId, this.editNameBoardId, this.boardNewName).subscribe((data: any) => {
       this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
         this.boardRenameStyle = "none";
         this.showRenameLoader = false;
         this.boards = data;
         this.boardname = '';
         this.sendSuccessful = true;
         this.successfullMessage = "Renamed " + this.boardCurrentName + " to " +this.boardNewName;
         this.hideSuccesfullFunctionErrorDelete();
       });
     },(error: any) => {
       if(error.status == 400){
         this.showRenameLoader = false;
         this.renameErrorMsg = error.error.message;
       } else {
         this.showRenameLoader = false;
         this.renameErrorMsg = error.error.message;
       }
    });
   }


   removeSearchTerm(index: number, searchTerm: any) {
     this.searchTerms.splice(index, 1);
     if(this.searchTerms.length > 0) {
       this.searchArrayImages(searchTerm, this.searchTerms);
     } else {
       this.videosViewSection = false;
       this.searchImageslistSection = true;
       this.imagesList = [];
     }
   }

   pinBoard(boardId: any) {
     this.damService.pinBoards(this.workspaceId, boardId).subscribe((data: any) => {
         this.getBoardsList();
     },
     (error) => {
       if(error.status == 400){
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.hideSuccesfullFunctionErrorDelete();
       } else {
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.hideSuccesfullFunctionErrorDelete();
       }
     });
   }

   unPinBoard(boardId: any) {
     this.damService.unPinBoards(this.workspaceId, boardId).subscribe((data: any) => {
         this.getBoardsList();
     },
     (error) => {
       if(error.status == 400){
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.hideSuccesfullFunctionErrorDelete();
       } else {
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.hideSuccesfullFunctionErrorDelete();
       }
     });
   }

   onSubmit() {
     if(this.searchText.length > 0) {
       this.searchTerms.push(this.searchText);
       this.searchArrayImages(this.searchText, this.searchTerms);
     }
   }

   searchArrayImages(searchText: any, searchTermArray: any){
     this.searchTextSet = searchText;
     this.damService.searchImagesArray(this.workspaceId, searchTermArray).subscribe((data: any) => {
       this.searchText = "";
       this.imagesList = data.image;
       this.searchData = '' + this.searchTextSet;
       this.videosViewSection = false;
       this.searchImageslistSection = true;
     });
   }

   openDeleteBoardShare(boardId: any, boardName: string) {
     this.deleteBoardId = boardId;
     this.deleteBoardName = boardName;
     this.deleteBoardStyle = "block";
   }

   closeDeleteBoardShare() {
    this.deleteBoardStyle = "none";
   }

   hideSuccesfullFunctionErrorDelete(){
     setTimeout(() => {
       this.sendSuccessful = false;
       this.showLinkCopied = false;
       this.sendSuccessfulErrorMsg = false;
     }, 5000);
   }

   showGeneratedLink() {
     this.isShowShareLinkGenerated = true;
   }

   selectExpireLink (event: any) {
     this.expiryLinkIn = event.target.value;
   }

   allowDownload() {
     if(this.allowDownloadSelected) {
       this.allowDownloadSelected = false;
     } else {
       this.allowDownloadSelected = true;
     }
   }

   copyShareLink(inputElement){
     if(this.allowDownloadSelected) {
       this.allowDownloads = 1;
     } else {
       this.allowDownloads = 0;
     }

     if(this.showCommentSelected) {
       this.showComments = 1;
     } else {
       this.showComments = 0;
     }

     if(this.allowCommentingSelected) {
       this.allowComments = 1;
     } else {
       this.allowComments = 0;
     }

     if(this.fromAssets) {
       this.subscriptionService.shareAssetsSettingsData(this.sharedToken,
         this.allowDownloads, this.expiryLinkIn, this.showComments, this.allowComments).subscribe((data) => {

       },(error: any) => {
         if(error.status == 400){
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
       });
     } else {
       this.subscriptionService.shareBoardsSettingsData(this.sharedToken,
         this.allowDownloads, this.expiryLinkIn, this.showComments, this.allowComments).subscribe((data) => {

       },(error: any) => {
         if(error.status == 400){
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
       });
     }
     inputElement.select();
     document.execCommand('copy');
     inputElement.setSelectionRange(0, 0);
     this.showLinkCopied = true;
     this.hideSuccesfullFunctionErrorDelete();
     // this.alert.message("copied");
   }

   changeColors(i){
     this.selectedIndex = i;
   }

   shareBoard() {
     this.fromAssets = false;
     this.shareImageLink = "";
     this.hitShareBoardApi();
   }

   hitShareBoardApi() {
     this.subscriptionService.hitBoardShare(this.workspaceId, this.boardId, "").subscribe((data) => {
       this.shareableLink = data.link;
       this.sharedToken = data.token;
       this.shareLinkStyle = "block";
       this.hideContent();
     },(error: any) => {
       this.hideContent();
       if(error.status == 400){
         this.sendSuccessfulErrorMsg = true
         this.sendSuccessfulErrorMessage = error.error.message;
         this.hideSuccesfullFunctionErrorDelete();
       } else {
         this.sendSuccessfulErrorMsg = true
         this.sendSuccessfulErrorMessage = error.error.message;
         this.hideSuccesfullFunctionErrorDelete();
       }
     });
   }

   closeShareLinkStyle() {
     this.imagesIds = [];
     this.shareImageLink = "";
     this.shareLinkStyle = "none";
   }

   hideContent() {
     this.imagesIds = [];
     this.count = 0;
   }

   verifyBoard(boardIds: any){
     this.sendSuccessful = false;
     this.showTopRightLoader = true;
     this.boardIdsList.push(boardIds);
     this.inboxService.verifyBoard(this.workspaceId, this.boardIdsList).subscribe((data: any) => {
       this.showTopRightLoader = false;
       this.sendSuccessful = true;
       this.successfullMessage = data.message;
       this.boardIdsList = [];
       this.hideSuccesfullFunctionErrorDelete();
     },(error: any) => {
       if(error.status == 400){
         this.showTopRightLoader = false;
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.boardIdsList = [];
         this.hideSuccesfullFunctionErrorDelete();
       } else {
         this.showTopRightLoader = false;
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.boardIdsList = [];
         this.hideSuccesfullFunctionErrorDelete();
       }
    });
   }

   goProClick() {
     this.router.navigate(['/dam/subscription']);
   }
}
